export default __webpack_public_path__ + "static/media/customer-img.a475679c.webp";